import React from 'react';
import { ReactComponent as TriangleLight } from '../../../../assets/img/figure/triangleLight.svg';
import { ReactComponent as TriangleDark } from '../../../../assets/img/figure/triangleDark.svg';
import { COLORS } from '../../../../store/colors';
import { FigureProps, FigureVariant } from './types';

const ASPECT_RATIO = 0.91;

export const FigureTriangle: React.FC<FigureProps> = ({
  className,
  variant = FigureVariant.dark,
  size = 100,
  unit = 'px',
  color,
  style
}) => {
  const figureStyle = {
    width: size !== 'auto' ? size + unit : undefined,
    height: size !== 'auto' ? size * ASPECT_RATIO + unit : undefined,
    color: color || COLORS.colorAccent100,
    ...style
  };

  if (color || variant === FigureVariant.light) {
    return <TriangleLight className={className} style={figureStyle} />;
  }
  return <TriangleDark className={className} style={figureStyle} />;
};
